/**
 * Предпросмотр подписки словами (T11.7, вынесено в T11.11).
 *
 * Числа считает сервер (`POST /v1/subscriptions/preview`, T7.10), а
 * читателей у них стало двое: карточка подписки из фильтров и
 * онбординг. Слова у них общие — иначе один экран сказал бы «подходит
 * больше 500», а другой «подходит 500», и разница между «ровно» и
 * «больше» пропала бы там, где она и важна.
 *
 * ## Оговорки не прячутся
 *
 * Счёт остановлен на пределе — сказано «больше»; оценка занижена —
 * сказано «не менее». Округлить это до бодрого числа значит обещать
 * человеку поток находок, которого не будет, либо тишину, которой он не
 * ждал.
 */

/** Приговор фильтру. Значения — как в `subscriptions/preview.ts`. */
export type Verdict = 'ok' | 'never' | 'too_many';

/** Ответ предпросмотра. Поля — как в `subscriptions/preview.ts`. */
export interface Preview {
  readonly matches_now: number;
  readonly matches_capped: boolean;
  readonly matches_in_window: number;
  readonly window_days: number;
  readonly per_day: number;
  readonly per_day_is_lower_bound: boolean;
  readonly daily_limit: number;
  readonly verdict: Verdict;
}

/** Сколько подходит сейчас — с учётом остановленного счёта. */
export function matches(preview: Preview): string {
  const count = preview.matches_now;

  if (preview.matches_capped) return `подходит больше ${String(count)}`;
  if (count === 0) return 'сейчас не подходит ничего';

  return `сейчас подходит ${String(count)}`;
}

/** Сколько будет приходить. Оценка занижена, и об этом сказано прямо. */
export function rate(preview: Preview): string {
  const about = preview.per_day_is_lower_bound ? 'не менее' : 'около';

  return `${about} ${String(preview.per_day)} в сутки`;
}

/**
 * Приговор фильтру человеческими словами.
 *
 * «Будет молчать» и «зальёт» — единственные два случая, ради которых
 * предпросмотр вообще существует, и оба названы прямо, вместе с тем, что
 * с ними делать.
 */
export function warning(preview: Preview): string | null {
  if (preview.verdict === 'never') {
    return `За ${String(preview.window_days)} дней не появилось ни одного подходящего. Такая подписка будет молчать — стоит ослабить условия.`;
  }

  if (preview.verdict === 'too_many') {
    return `Это больше суточной квоты тарифа (${String(preview.daily_limit)}), и часть находок до вас не дойдёт. Стоит сузить условия.`;
  }

  return null;
}
